export default __webpack_public_path__ + "static/media/Staatliches-Regular.a7f803c1.ttf";